import { Partner } from '../../../model/shared/transaction/partner';
import { BaseResponse } from '../baseresponse';

export class PayoutCountry {
  name: string;
  value: string;
  partner: Array<Partner>;
}


export class PayoutCountryList {
  total: number;
  list: Array<PayoutCountry>;
}


export class PayoutCountryListResult extends BaseResponse {
  data: PayoutCountryList;
}




// WEBPACK FOOTER //
// ./src/app/response/internal/list/payoutcountrylist.ts